import defaults from '../translationDefaults/en';
export const hasFormSubmission = form => (form === null || form === void 0 ? void 0 : form.formsubmission) && form.formsubmission !== '[null]';
export const hasArchive = res => !hasFormSubmission(res) && res.documentarchives && res.documentarchives.length && res.documentarchives[0].archivestatus === 'Archived' && res.documentarchives[0].url;
export const bucketFetch = async (res, keycloak, setgApi, setFormError) => {
  const archivesRes = res.documentarchives[0];
  const archivesResURL = archivesRes === null || archivesRes === void 0 ? void 0 : archivesRes.url;
  const url = `${process.env.REACT_APP_BUCKET_GATEWAY_URL}/${archivesResURL}`;

  if (url && archivesResURL) {
    const headers = new Headers();

    if (keycloak && !(keycloak !== null && keycloak !== void 0 && keycloak.token)) {
      keycloak.logout();
      return;
    } // clinical server takes keycloak as separate header,
    // everything else uses it as a bearer token


    const tokenExpirytime = parseInt(process.env.REACT_APP_TOKEN_VALIDITY_IN_SECONDS);

    if (keycloak) {
      await keycloak.updateToken(tokenExpirytime);
      headers.set('Authorization', `Bearer ${keycloak.token}`); // eslint-disable-next-line consistent-return

      await fetch(`${url}`, {
        headers,
        credentials: 'same-origin'
      }).then(async response => {
        if (response.ok && response.status === 200) {
          const decoder = new TextDecoder('utf-8');
          const reader = response.body.getReader();
          let html = '';
          await reader.read().then(async function processText({
            done,
            value
          }) {
            if (done) {
              await fetchStorage(html, setgApi, setFormError);
              return;
            }

            html += decoder.decode(value);
            reader.read().then(processText);
          });
        } else {
          setFormError(defaults.errorForm);
        }

        return null;
      }).catch(err => 'There was an error');
    }
  }
};
export const fetchStorage = async (url, setgApi, setFormError) => {
  if (url) {
    const headers = new Headers();
    headers.set('Content-Type', `text/plain`);
    await fetch(`${url}`, {
      headers,
      mode: 'cors'
    }).then(async response => {
      if (response.ok && response.status === 200) {
        const decoder = new TextDecoder('utf-8');
        const reader = response.body.getReader();
        let html = '';
        await reader.read().then(function processText({
          done,
          value
        }) {
          if (done) {
            const resHtml = getArchiveJson(html);
            setgApi(resHtml);
            return;
          }

          html += decoder.decode(value);
          reader.read().then(processText);
        });
      } else {
        setFormError(defaults.errorForm);
      }

      return null;
    }).catch(err => 'There was an error');
  }

  return null;
};
export const getArchiveJson = gApi => {
  let resGApi = gApi;

  if (typeof gApi === 'string') {
    const parsedGApi = JSON.parse(gApi);

    if (parsedGApi && parsedGApi.length && parsedGApi.length === 1) {
      const gApiAns = parsedGApi[0];

      if (Array.isArray(gApiAns)) {
        resGApi = JSON.stringify(gApiAns);
      }
    }
  }

  return resGApi;
};